var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_878_17648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.29594 15.4877L4.5721 15.4105C4.83772 15.3363 4.99287 15.0608 4.91865 14.7951L1.76133 3.49629C1.71678 3.33684 1.6107 3.20161 1.46645 3.12037C1.32219 3.03912 1.15157 3.01851 0.992115 3.06308L0.956451 3.07303C0.624389 3.16581 0.43041 3.51021 0.523184 3.84227L3.68058 15.1411C3.7548 15.4067 4.03031 15.5619 4.29594 15.4877Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4152 7.59173C14.414 7.09248 13.4877 6.45524 12.6635 5.69863C12.5942 5.63521 12.5671 5.53786 12.5937 5.44777C13.002 3.90282 13.3053 2.33199 13.5014 0.746051C13.5325 0.482258 13.3902 0.404672 13.2402 0.585706C10.2971 4.10553 5.20486 -0.058259 2.17383 3.14088C2.21022 3.20901 2.23885 3.28101 2.25917 3.35553L4.30745 10.69C7.34366 7.52966 12.4178 11.6676 15.3557 8.15553C15.5057 7.97449 15.5342 7.64346 15.4152 7.59173Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_878_17648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "currentColor",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.eaf3e3c1e454641627141a1a76aa23b1.svg";
export { ForwardRef as ReactComponent };